module.exports = __webpack_public_path__ + "img/bank-of-america.9fd0fe38.png";